import { fileExtensionToMimeTypeDir } from '../../../../resources/json/extension-to-mime-type'

export function extensionsToMimeTypesString(extensions: string[]) {
  return extensionsToMimeTypes(extensions).join(', ')
}

export function extensionsToMimeTypes(extensions: string[]) {
  return extensions.map(ex => fileExtensionToMimeTypeDir[ex])
}